import React, { useState, useEffect, Fragment } from "react";
import { useLocation } from "react-router-dom";
import { useDeviceGroups } from "../../Api/newSockets.api";
import DeviceListItem from "../../domain/Devices/DeviceListItem";
import GroupListItem from "../../domain/Devices/GroupListItem";
import UserService from "../../services/UserService";
import "../../styles/components/settingsmainpage.scss";
import { savePathToLocalStorage } from "../../utils/helpers";
import Accordion from "../Accordion/Accordion";
import Checkbox from "../Checkbox/Checkbox";

const SettingsMainPage = () => {
  savePathToLocalStorage();
  const { deviceGroups } = useDeviceGroups();

  const data = deviceGroups;

  console.log(data);
  return (
    <div>
      <Accordion title="General">
        {/* {device && (
              <div>
                {device.map((device: any, i: any) => {
                  return <li>{device.name[0]}</li>;
                })}
              </div>
            )} */}
      </Accordion>
      <Accordion title="System"></Accordion>
      <Accordion title="Smart alerts"></Accordion>
    </div>
  );
};

export default SettingsMainPage;
